module.exports = __webpack_public_path__ + "static/media/0.49aed11c.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/body/0.png
// module id = 133
// module chunks = 0